import React from 'react';
import close from "../../../assets/Icons/close.png";
import blur from "../../../assets/invalidImage/blur.png";
import "../signal.css";

const BlurDetectedError = ({ onClose, onRetake, onViewReference }) => {
    return (
        <div className="h-full bg bg-transparent w-full flex justify-center items-center">
            <div className="bg-white w-11/12 max-w-md flex flex-col items-center p-6 rounded-lg shadow-xl">
                <div className="flex justify-between w-full mb-4">
                    <p className="text-red-600 text-2xl font-semibold">ပုံမမှန်းဓါတ်!</p>
                    <button type="button" onClick={onClose}>
                        <img src={close} className="w-7 h-7" alt="close" />
                    </button>
                </div>
                <div className="text-base py-3 px-4 w-full">
                    <p className="font-semibold my-1 text-signal-ai-blue">ပုံမမှန်းဓါတ်၊ ဤြားဖြစ်နို့ရှာနောင်ပါ</p>
                    <p className="flex my-4 text-signal-ai-blue">
                        <img src={blur} alt="blur" className="w-5 h-5 me-3" />
                        <span>ပုံထွက်ဝါးနေပါသည်</span>
                    </p>
                </div>
                <div className="w-full space-y-3">
                    <button
                        type="button"
                        className="bg-white text-signal-ai-blue font-normal text-base w-full h-11 border border-signal-ai-primary rounded-lg"
                        onClick={onViewReference}
                    >
                        ရည်မှတ်ကြည့်ကြည့်
                    </button>
                    <button
                        type="button"
                        className="bg-signal-ai-secondary text-white w-full h-11 font-semibold text-base shadow-2xl rounded-lg"
                        onClick={onRetake}
                    >
                        ပုံရိုက်မည်
                    </button>
                </div>
            </div>
        </div>
    );
};

export default BlurDetectedError;
